export const obtenerDimencionTotal = (productos) => {

    let centimetrosCubicos = 0
    for (let i = 0; i < productos.length; i++) {
        let producto = productos[i]
        let volumen = (parseInt(producto.alto) * parseInt(producto.ancho) * parseInt(producto.fondo)) * producto.cantidad
        centimetrosCubicos = centimetrosCubicos + volumen
    }

    let arista = Math.cbrt(centimetrosCubicos)
    arista = arista + 1

    let dimencionTotal = {
        alto:  20,
        ancho: 30,
        fondo:  5,
    }

    return dimencionTotal

}